import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroLead from "@/pages/home/components/HeroLead";
import FeedSection from "@/pages/home/components/FeedSection";
import SpotlightSection from "@/pages/home/components/SpotlightSection";
import EventTimeline from "@/pages/home/components/EventTimeline";
import FieldsSection from "@/pages/home/components/FieldsSection";
import CommunitySection from "@/pages/home/components/CommunitySection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-900">
      <SiteHeader />
      <main>
        <HeroLead />
        <FeedSection />
        <SpotlightSection />
        <EventTimeline />
        <FieldsSection />
        <CommunitySection />
      </main>
      <SiteFooter />
    </div>
  );
}